<script setup lang="ts">
import type {
	TFilterObject,
	TPagination,
	TTeacher,
} from "@/assets/js/globalTypes";
import { useTeacherStore } from "@/store/teacher";
import { useSuperAdminStore } from "@/store/superadmin";
import type { DataTablePageEvent } from "primevue/datatable";
import { $t } from "@/i18n";

defineOptions({
	name: "admin.teachers.all",
});
definePage({
	name: "admin.teachers.all",
	meta: {
		hasKeepAlive: ["admin.teachers.profile"],
		permissions: "view-teacher-management",
		readableName: "All profiles",
	},
});

const router = useRouter();
const route = useRoute();
const teacherStore = useTeacherStore();
const superAdminStore = useSuperAdminStore();

const currentPage = computed(() => {
	return router.currentRoute.value.query.page;
});

const rows = ref(10);
const teachers = ref([]);
const pagination = ref<TPagination>();
const filterOptions = ref<TFilterObject[]>([
	{ label: $t("app.admin.teacher.filterOptions.active"), value: "Active" },
	{ label: $t("app.admin.teacher.filterOptions.inactive"), value: "Inactive" },
	{ label: $t("app.admin.teacher.filterOptions.banned"), value: "Banned" },
]);

onActivated(() => {
	getTeachers();
});
onBeforeMount(() => {
	getTeachers();
});

watch(
	() => currentPage.value,
	() => {
		getTeachers();
	},
);

const getTeachers = async () => {
	try {
		const params = {
			page: Number(currentPage.value) || 1,
			per_page: rows.value || 20,
			usr_fullname: superAdminStore.teacherName,
			usr_status: superAdminStore.filter?.value + "",
		};
		const response = await teacherStore.fetchAllTeachers(params);
		pagination.value = response.meta.pagination;
		teachers.value = response.data;
		console.log(pagination.value);
	} catch (error) {
		console.error(error);
	}
};

const resetPage = () => {
	router.replace({
		query: {
			page: 1,
		},
	});
};

const updateRows = (row: number) => {
	if (row === rows.value) return;
	rows.value = row;
	getTeachers();

	// if (currentPage.value === "1") {
	// 	console.log("pozvao sam se iz updateRows");

	// 	getTeachers();
	// } else {
	// 	console.log("pozvao sam se iz updateRows al nisam trebao da se pozovem");

	// 	resetPage();
	// }
};

const changePage = (event: DataTablePageEvent) => {
	router.push({
		query: {
			...route.query,
			page: event.page + 1,
		},
	});
};

const handleFilter = (filterOption: TFilterObject) => {
	superAdminStore.filter = filterOption;
	if (currentPage.value === "1") {
		getTeachers();
	} else {
		resetPage();
	}
};

const handleSearch = (search: string) => {
	superAdminStore.teacherName = search;
	if (currentPage.value === "1") {
		getTeachers();
	} else {
		resetPage();
	}
};
// TODO: Change the functionality when it's determnied what it does
const handleProfile = (data: TTeacher) => {
	// console.log(data);
	router.push({
		name: "admin.teachers.public-profile",
		params: { id: data.usr_id },
	});
};
</script>

<template>
	<div id="admin-teachers-all">
		<TeacherTable
			:title="$t('app.teacher.allTitle')"
			:teachers="teachers"
			:filter-options="filterOptions"
			:uses-created-date="true"
			:alt-preview="true"
			:rows="rows"
			:page="Number(currentPage || 1)"
			:total-records="pagination?.total"
			:search="superAdminStore.teacherName"
			:filter="superAdminStore.filter"
			@filter="handleFilter"
			@search="handleSearch"
			@update:page="changePage"
			@update:rows="updateRows"
			@table-action="handleProfile"
		>
			<!-- <template #action="slotProps">
				<p-button
					:label="$t('app.base.profile')"
					@click="handleProfile(slotProps.data)"
				/>
			</template> -->
		</TeacherTable>
	</div>
</template>

<style scoped lang="scss"></style>
